import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CircularProgress } from '@mui/material';
import React from 'react';

import ToolbarIconButton from './ToolbarIconButton';

/**
 * Toolbar-styled download/export button. Wraps `ToolbarIconButton`
 * with the standard FileDownload icon so every export action across
 * the app matches the same chrome.
 *
 * Pass `loading` to swap the icon for a CircularProgress while an
 * export is in flight.
 */
export default function DownloadButton({ tooltip = 'Export', onClick, disabled, loading, ...rest }) {
  return (
    <ToolbarIconButton tooltip={tooltip} onClick={onClick} disabled={disabled || loading} {...rest}>
      {loading ? <CircularProgress size={16} /> : <FileDownloadIcon fontSize="small" />}
    </ToolbarIconButton>
  );
}
